import React from 'react';

import * as Styled from './index.styles';

const Body = ({ children }: React.PropsWithChildren) => {
  return <Styled.FlexWrapper marginBottom={16}>{children}</Styled.FlexWrapper>;
};

export default Body;
